import React from 'react';
import { Utils } from '../../services';
import i18n from '../../locales/i18n';
import MultiSelectField from '../MultiSelectField/MultiSelectField';
import SelectField from '../SelectField/SelectField';

import './LangsField.css';

/**
 * @param {boolean} [includeNoDialog=false] When true, prepend the pseudo-language `no_lang` (silent / no dialog).
 * @param {boolean} [onlyUiLocales=false] Restrict options to configured UI locales (e.g. QR configuration).
 */
const LangsField = ({ name, multi, onChange, required, includeNoDialog = false, onlyUiLocales = false, disabled, compact }) => {
    const uiLang = Utils.i18nUiLang(i18n);
    let options = Utils.sorted_standard_languages(uiLang, { includeNoDialog });

    if (onlyUiLocales) {
        const order = Utils.langs();
        const allowed = new Set(order);
        options = options.filter((o) => allowed.has(o.code));
        options = [...options].sort((a, b) => order.indexOf(a.code) - order.indexOf(b.code));
    }

    options = options.map((l) => ({
        key: l.code,
        text: l.language,
        value: l.code,
    }));

    if (multi) {
        return <MultiSelectField name={name} options={options} onSelectChange={onChange} disabled={disabled} compact={compact} />;
    }

    return (
        <SelectField
            name={name}
            options={options}
            onSelectChange={onChange}
            clearable={!required}
            disabled={disabled}
            compact={compact}
        />
    );
};

export default LangsField;
